import * as S from "@styled";
import { environmentColorMap } from "environments/components/EnvironmentColorSelector";
import { device } from "shared/styles/helpers";
import { IVariantProps, NavBarHeight, ThemeType } from "shared/styles/theme";
import styled from "styled-components";
import theme from "styled-theming";

export enum NavbarVariant {
    default = "default",
    purple = "purple",
    orange = "orange",
    pink = "pink",
    blue = "blue",
    green = "green",
}

const lightPurple = environmentColorMap[ThemeType.light].purple;
const darkPurple = environmentColorMap[ThemeType.dark].purple;

const lightOrange = environmentColorMap[ThemeType.light].orange;
const darkOrange = environmentColorMap[ThemeType.dark].orange;

const lightPink = environmentColorMap[ThemeType.light].pink;
const darkPink = environmentColorMap[ThemeType.dark].pink;

const lightBlue = environmentColorMap[ThemeType.light].blue;
const darkBlue = environmentColorMap[ThemeType.dark].blue;

const lightGreen = environmentColorMap[ThemeType.light].green;
const darkGreen = environmentColorMap[ThemeType.dark].green;

const navbarBackgroundColor = theme.variants("mode", "variant", {
    [NavbarVariant.default]: { [ThemeType.light]: S.Colors.white, [ThemeType.dark]: S.Colors.dark },
    [NavbarVariant.purple]: { [ThemeType.light]: lightPurple.backgroundColor, [ThemeType.dark]: darkPurple.backgroundColor },
    [NavbarVariant.orange]: { [ThemeType.light]: lightOrange.backgroundColor, [ThemeType.dark]: darkOrange.backgroundColor },
    [NavbarVariant.pink]: { [ThemeType.light]: lightPink.backgroundColor, [ThemeType.dark]: darkPink.backgroundColor },
    [NavbarVariant.blue]: { [ThemeType.light]: lightBlue.backgroundColor, [ThemeType.dark]: darkBlue.backgroundColor },
    [NavbarVariant.green]: { [ThemeType.light]: lightGreen.backgroundColor, [ThemeType.dark]: darkGreen.backgroundColor },
});

const navbarBorderColor = theme.variants("mode", "variant", {
    [NavbarVariant.default]: { [ThemeType.light]: S.Colors.grey_3, [ThemeType.dark]: S.Colors.dark2 },
    [NavbarVariant.purple]: { [ThemeType.light]: lightPurple.borderColor, [ThemeType.dark]: darkPurple.borderColor },
    [NavbarVariant.orange]: { [ThemeType.light]: lightOrange.borderColor, [ThemeType.dark]: darkOrange.borderColor },
    [NavbarVariant.pink]: { [ThemeType.light]: lightPink.borderColor, [ThemeType.dark]: darkPink.borderColor },
    [NavbarVariant.blue]: { [ThemeType.light]: lightBlue.borderColor, [ThemeType.dark]: darkBlue.borderColor },
    [NavbarVariant.green]: { [ThemeType.light]: lightGreen.borderColor, [ThemeType.dark]: darkGreen.borderColor },
});

const navbarTextColor = theme("mode", {
    [ThemeType.light]: S.Colors.black,
    [ThemeType.dark]: S.Colors.grey_5
})

const dropdownNavLink = theme("mode", {
    [ThemeType.light]: S.Colors.purplePrimary,
    [ThemeType.dark]: S.Colors.purpleTertiary
})

export const Navbar = styled.ul<IVariantProps<NavbarVariant>>`
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px 10px 8px 8px;
    @media ${device.laptopL} {
        padding: 8px 10px 8px 24px;
    }
    width: 100%;
    height: ${NavBarHeight};
    font-size: 1rem;
    visibility: hidden;
    background-color: ${navbarBackgroundColor};
    border-bottom: 1px solid ${navbarBorderColor};
    li {
        float: left;
        padding: 14px;

        a > i {
            font-size: var(--header-4-font-size);
        }
    }

    .frends-logo {
        padding: 0 16px 0 0;
    }

`

export const NavLinkContainer = styled.div`
    display: flex;
    @media ${device.laptopL} {
        height: 100%;
        flex-wrap: wrap;
        align-content: center;
        a, li {
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
`

export const NavLink = styled.a<IVariantProps<NavbarVariant>>`
    display: flex;
    cursor: pointer;
    color: ${navbarTextColor};
    font-family: "Gilroy-Medium", "medium-fallback";
    font-size: 1rem;
    text-decoration: none;
    &.active {
        font-family: "Gilroy-Bold", "bold-fallback";
    }
`

export const DropdownNavLink = styled(NavLink)`
    &.active {
        font-family: "Gilroy-Medium", "medium-fallback";
        color: ${dropdownNavLink};
    }
`

export const NavText = styled.p`
    font-family: "Gilroy-Medium", "medium-fallback";
    font-size: 1rem;
`

export const NavMobileExpandButton = styled(S.Button)`
    margin-right: 10px;
    padding: 8px;
    border: 0;
    border-radius: 16px;
    font-size: 1.75rem;
    display: flex;
    align-items: center;
    cursor: pointer;
`

NavLink.defaultProps = {
    variant: NavbarVariant.default
};